import { useMutation, useQueryClient } from 'react-query';

import type { IStandardErrorResponse } from 'src/api/common';
import type { IContact } from 'src/services/api/contacts/types';
import { apiClient } from 'src/services/api/client';
import { queryKeys } from 'src/services/api/constants';
import { CONTACTS_PATH } from 'src/services/api/contacts/constants';

export type ICreateContactRequest = {
    email: string;
    name?: string | null;
    phone_number?: string | null;
    property_ids?: number[];
};

type ICreateContactResponse = {
    contact: IContact;
};

export const useCreateContact = () => {
    const queryClient = useQueryClient();

    return useMutation<IContact, IStandardErrorResponse, ICreateContactRequest>(
        async (payload) => {
            const res = await apiClient(CONTACTS_PATH, {
                method: 'post',
                json: payload,
            }).json<ICreateContactResponse>();

            return res.contact;
        }, {
            onSuccess: () => {
                queryClient.invalidateQueries(queryKeys.contacts);
            }
        }
    );
};
